import { cn } from '../../ui';
import { Switch } from 'react-aria-components';

type PrinterSwitchProps = {
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
  isDisabled?: boolean;
  'aria-label': string;
};

/* The kit has no Switch yet, so React Aria's, drawn with the kit's tokens. */
export function PrinterSwitch({
  isSelected,
  onChange,
  isDisabled,
  'aria-label': ariaLabel,
}: PrinterSwitchProps) {
  return (
    <Switch
      isSelected={isSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      aria-label={ariaLabel}
      className="sk:group/switch sk:inline-flex sk:cursor-pointer sk:items-center sk:rac-disabled:cursor-not-allowed sk:rac-disabled:opacity-50"
    >
      {({ isSelected: on }) => (
        <span
          className={cn(
            'sk:flex sk:h-4.5 sk:w-8 sk:shrink-0 sk:items-center sk:rounded-full sk:p-0.5',
            'sk:transition-colors sk:duration-100',
            on
              ? 'sk:bg-primary'
              : 'sk:bg-fill-secondary sk:inset-shadow-hairline',
            'sk:group-rac-focus-visible/switch:outline-2 sk:group-rac-focus-visible/switch:outline-solid sk:group-rac-focus-visible/switch:outline-offset-1 sk:group-rac-focus-visible/switch:outline-primary',
          )}
        >
          <span
            className={cn(
              'sk:size-3.5 sk:rounded-full sk:bg-surface sk:shadow-card',
              'sk:transition-transform sk:duration-100',
              on && 'sk:translate-x-3.5',
            )}
          />
        </span>
      )}
    </Switch>
  );
}
